module.exports = __webpack_public_path__ + "media/images/warning-sign-410f1a17bef343ca047e494180954031.svg";